// useBlockHorizontalScroll.js
import { useRef, useEffect } from "react";

/**
 * This hook intercepts touch events and, if the user tries to scroll
 * more horizontally than vertically, we call e.preventDefault().
 *
 * If you want to block *all* scrolling (both horizontal + vertical),
 * just remove the direction check and always e.preventDefault() inside handleTouchMove.
 */
export default function useBlockHorizontalScroll(enabled = false) {
  const startX = useRef(0);
  const startY = useRef(0);

  useEffect(() => {
    function handleTouchStart(e) {
      if (!enabled) return;
      // Store initial touch coordinates
      const touch = e.touches[0];
      startX.current = touch.pageX;
      startY.current = touch.pageY;
      console.log(
        "[useBlockHorizontalScroll] touchstart =>",
        startX.current,
        startY.current
      );
    }

    function handleTouchMove(e) {
      if (!enabled) return;

      const touch = e.touches[0];
      const diffX = touch.pageX - startX.current;
      const diffY = touch.pageY - startY.current;

      // If the horizontal distance is greater than the vertical distance => horizontal scroll
      if (Math.abs(diffX) > Math.abs(diffY)) {
        console.log(
          "[useBlockHorizontalScroll] Blocking H-swipe => diffX:",
          diffX,
          " diffY:",
          diffY
        );
        e.preventDefault();
      } else {
        console.log(
          "[useBlockHorizontalScroll] Not blocking => mostly vertical => diffX:",
          diffX,
          " diffY:",
          diffY
        );
      }
    }

    // Important: passive:false is needed so we can call e.preventDefault()
    window.addEventListener("touchstart", handleTouchStart, { passive: false });
    window.addEventListener("touchmove", handleTouchMove, { passive: false });

    return () => {
      window.removeEventListener("touchstart", handleTouchStart, {
        passive: false,
      });
      window.removeEventListener("touchmove", handleTouchMove, {
        passive: false,
      });
    };
  }, [enabled]);
}
